// Função utilitária para gerar URLs de ícones
export function getIconUrl(iconPath: string | null | undefined): string | null {
  if (!iconPath) return null;
  
  // Se já contém o caminho completo (icons/ ou tech-icons/)
  if (iconPath.startsWith('icons/') || iconPath.startsWith('tech-icons/')) {
    return `/assets/${iconPath}`;
  }
  
  // Fallback para compatibilidade com dados antigos
  return `/assets/icons/${iconPath}`;
}